import type { BlogPost } from '@entities/Blog/types/types'

import { useAllTextMaterialsQuery, useSingleTextMaterialQuery } from '@shared/generated'



interface UseBlogPostResult {
  data: BlogPost | null;
  loading: boolean;
  error?: Error;
}

export const useBlogPost = ({
  slug,
  id
}: {
  slug?: string,
  id?: string
}): UseBlogPostResult => {
  const { data, loading, error } = useSingleTextMaterialQuery({
    variables: { slug, singleTextMaterialId: id },
    skip: !slug && !id,
  })

  const blogPost = data?.singleTextMaterial as BlogPost | null

  return {
    data: blogPost,
    loading,
    error: error ? new Error(error.message) : undefined,
  }
}

interface RelatedBlogPostsProps {
  categorySlug?: string;
  themeSlug?: string;
  excludeId?: string;
}

export function useRelatedBlogPosts ({
  categorySlug,
  themeSlug,
  excludeId
}: RelatedBlogPostsProps) {
  const { data, loading, error } = useAllTextMaterialsQuery({
    variables: {
      filter: {
        and: [
          ...themeSlug ? [ {
            fields: [ 'themeSlug' ],
            op: 'eq',
            value: [ themeSlug ]
          } ] : [],
          ...categorySlug ? [ {
            fields: [ 'categorySlug' ],
            op: 'eq',
            value: [ categorySlug ]
          } ] : [],
          {
            fields: [ 'typeSlug' ],
            op: 'not_eq',
            value: [ 'static' ] // Exclude "static" type
          },
          {
            fields: [ 'id' ],
            op: excludeId ? 'not_eq' : 'unwrap',
            value: [ excludeId || '' ]
          }
        ]
      },
    },
    skip: !categorySlug && !themeSlug,
  })

  return {
    data: data?.allTextMaterials?.edges as BlogPost[] || [],
    loading,
    error: error ? new Error(error.message) : undefined,
  }
};